import React from "react";
import { Modal } from "@nef/core";

import { useGlobalModalContext } from "../../../context/modal-context";
import "./style.scss";

export const ESGWelcome = () => {
  const { hideModal } = useGlobalModalContext();

  return (
    <Modal size="md" isOpen={true} toggle={hideModal}>
      <div className="esg-welcome-container">
        <h3 className="header">Welcome to the ESG Data Hub</h3>

        <p className="content">
          Connecting pioneering ESG data providers with the global investment
          community.
        </p>

        <div className="definitions">
          <div>
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/icons/environmental.svg`}
              alt="environmental"
            />
          </div>
          <div>
            <h5 className="definition-name">Environmental</h5>
            <p className="definition-description">
              The environmental practices and the associated climate risks of
              global issuers
            </p>
          </div>
          <div>
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/icons/social.svg`}
              alt="social"
            />
          </div>
          <div>
            <h5 className="definition-name">Social</h5>
            <p className="definition-description">
              Company practices across its workforce, towards its clients,
              within the communities it operates.
            </p>
          </div>
          <div>
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/icons/governance.svg`}
              alt="governance"
            />
          </div>
          <div>
            <h5 className="definition-name">Governance</h5>
            <p className="definition-description">
              How a company is managed, including board diversity, internal, and
              external controls on bad practices.
            </p>
          </div>
        </div>

        <div className="actions">
          <button
            className="b-button b-button--blue"
            type="button"
            onClick={() => hideModal()}
          >
            Continue
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ESGWelcome;
